export const IMPORTING_GL_JOURNALS = 'IMPORTING_GL_JOURNALS';
export const IMPORTING_GL_JOURNALS_SUCCESS = 'IMPORTING_GL_JOURNALS_SUCCESS';
export const IMPORTING_GL_JOURNALS_FAILURE = 'IMPORTING_GL_JOURNALS_FAILURE';

export const FETCH_GL_ACCOUNTS = 'FETCH_GL_ACCOUNTS';
export const FETCH_GL_ACCOUNTS_SUCCESS = 'FETCH_GL_ACCOUNTS_SUCCESS';
export const FETCH_GL_ACCOUNTS_FAILURE = 'FETCH_GL_ACCOUNTS_FAILURE';

export const FETCH_TAXENTRY_TYPES = 'FETCH_TAXENTRY_TYPES';
export const FETCH_TAXENTRY_TYPES_SUCCESS = 'FETCH_TAXENTRY_TYPES_SUCCESS';
export const FETCH_TAXENTRY_TYPES_FAILURE = 'FETCH_TAXENTRY_TYPES_FAILURE';

export const FETCH_TAXENTRY_ACTIVITIES = 'FETCH_TAXENTRY_ACTIVITIES';
export const FETCH_TAXENTRY_ACTIVITIES_SUCCESS = 'FETCH_TAXENTRY_ACTIVITIES_SUCCESS';
export const FETCH_TAXENTRY_ACTIVITIES_FAILURE = 'FETCH_TAXENTRY_ACTIVITIES_FAILURE';

export const FETCH_SL_ACCOUNTS_FOR_GL_JOURNALS = 'FETCH_SL_ACCOUNTS_FOR_GL_JOURNALS';
export const FETCH_SL_ACCOUNTS_FOR_GL_JOURNALS_SUCCESS = 'FETCH_SL_ACCOUNTS_FOR_GL_JOURNALS_SUCCESS';
export const FETCH_SL_ACCOUNTS_FOR_GL_JOURNALS_FAILURE = 'FETCH_SL_ACCOUNTS_FOR_GL_JOURNALS_FAILURE';

export const FETCH_SL_TAX_ENTRIES_FOR_GL_JOURNALS = 'FETCH_SL_TAX_ENTRIES_FOR_GL_JOURNALS';
export const FETCH_SL_TAX_ENTRIES_FOR_GL_JOURNALS_SUCCESS = 'FETCH_SL_TAX_ENTRIES_FOR_GL_JOURNALS_SUCCESS';
export const FETCH_SL_TAX_ENTRIES_FOR_GL_JOURNALS_FAILURE = 'FETCH_SL_TAX_ENTRIES_FOR_GL_JOURNALS_FAILURE';

export const FETCHING_INITIAL_DATA_FOR_GL_JOURNAL_ADD_EDIT_MODAL = 'FETCHING_INITIAL_DATA_FOR_GL_JOURNAL_ADD_EDIT_MODAL';
export const FETCHING_INITIAL_DATA_FOR_GL_JOURNAL_ADD_EDIT_MODAL_FINISHED = 'FETCHING_INITIAL_DATA_FOR_GL_JOURNAL_ADD_EDIT_MODAL_FINISHED';
